module.exports = __webpack_public_path__ + "media/flags/ve-3a0ada18.svg";